import { Component, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-preview-pdf-dialog",
  //standalone: true,
  //imports: [],
  templateUrl: "./preview-pdf-dialog.component.html",
  styleUrl: "./preview-pdf-dialog.component.scss",
})
export class PreviewPdfDialogComponent {
  loadingModal: boolean = false;
  selectedPreviewUrl;
  xmlContent: string = "";
  fileType: "pdf" | "xml" = "pdf";

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<PreviewPdfDialogComponent>,
  ) {
    this.fileType = data.fileType || "pdf";

    if (this.fileType === "pdf") {
      this.selectedPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        data.selectedPreviewUrl,
      );
    } else {
      const decodedText = this.decodeBase64ToXml(data.xmlContent);
      this.xmlContent = this.formatXml(decodedText);
    }
  }

  // Función robusta para decodificar Base64 a texto plano con soporte UTF-8
  private decodeBase64ToXml(base64Str: string): string {
    if (!base64Str) return "";
    try {
      // Limpiamos espacios o saltos de línea por si acaso
      const cleanBase64 = base64Str.trim();

      // Decodifica la cadena Base64 a binario
      const binaryString = atob(cleanBase64);

      // Convierte el binario a bytes UTF-8 para respetar acentos y caracteres especiales del XML
      const bytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));
      const decoder = new TextDecoder("utf-8");
      return decoder.decode(bytes);
    } catch (e) {
      // Si por alguna razón ya era texto plano, lo regresa tal cual
      return base64Str;
    }
  }

  ngOnInit() {}

  // Cierras el modal con el event 2 para que el padre sepa que no se puede enviar al back la data
  closeDialog() {
    this.dialogRef.close({ event: 2 });
  }
  // Cierras el modal con el event 1 para que el padre sepa que se puede enviar al back la data
  save() {
    this.loadingModal = true;
    this.dialogRef.close({ event: 1 });
  }

  closePreview() {
    this.dialogRef.close({ event: 1 });
  }

  private formatXml(xml: string): string {
    let formatted = "";
    let indent = "";
    const tab = "    "; // 4 espacios de sangría
    xml.split(/>\s*</).forEach((node) => {
      if (node.match(/^\/\w/)) indent = indent.substring(tab.length);
      formatted += indent + "<" + node + ">\r\n";
      if (node.match(/^^\w([^?\/]|([^\/]\/))>$/)) indent += tab;
    });
    return formatted.substring(1, formatted.length - 3);
  }
}
